import {BorderRadius} from '@mintdata/mint-kit/api/models/BorderRadius';
import {FieldPath} from '@mintdata/mint-kit/api/properties/BindPath';
import {BaseFieldConverter} from '@mintdata/mint-kit/impl/properties/converters/BaseFieldConverter';

export class BorderRadiusConverter extends BaseFieldConverter<BorderRadius>
{
    public static readonly VALUE:FieldPath = 'value.unitsString';
    public static readonly TOP_LEFT:FieldPath = 'topLeft.unitsString';
    public static readonly TOP_RIGHT:FieldPath = 'topRight.unitsString';
    public static readonly BOTTOM_RIGHT:FieldPath = 'bottomRight.unitsString';
    public static readonly BOTTOM_LEFT:FieldPath = 'bottomLeft.unitsString';
}
